import React from 'react';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
  className?: string;
  for?: string;
}

export const Label: React.FC<LabelProps> = ({ children, className = '', ...props }) => {
  return (
    <label className={`block mb-2 text-sm font-medium text-[var(--color-dark)] ${className || ''}`} {...props}>
      {children}
    </label>
  );
};
